/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import t from 'tcomb-validation';
import { defineSchema } from 'schemas';

export const DocumentStoreKVP = defineSchema({
  value: t.maybe(t.Any)
}, 'DocumentStoreKVP');
